import { render, staticRenderFns } from "./reporterTable.vue?vue&type=template&id=f5724a1c&scoped=true"
import script from "./reporterTable.vue?vue&type=script&lang=ts"
export * from "./reporterTable.vue?vue&type=script&lang=ts"
import style0 from "./reporterTable.vue?vue&type=style&index=0&id=f5724a1c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5724a1c",
  null
  
)

export default component.exports